import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment-timezone";

const ProviderProfileForm = ({ provider }) => {
  const [updatedProvider, setUpdatedProvider] = useState({
    firstname: provider.firstname || "",
    lastname: provider.lastname || "",
    email: provider.email || "",
    time_zone: provider.time_zone || moment.tz.guess() || 'UTC',
  });

  const [errors, setErrors] = useState({});
  const [isEdited, setIsEdited] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const hasChanges = Object.keys(updatedProvider).some(
      (key) => updatedProvider[key] !== provider[key]
    );
    setIsEdited(hasChanges);
  }, [updatedProvider, provider]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProvider({
      ...updatedProvider,
      [name]: value,
    });
    setIsEdited(true);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!updatedProvider.firstname || updatedProvider.firstname.length > 50) {
      newErrors.first_name = "First name must be up to 30 characters long";
      toast.error(newErrors.first_name);
    }

    if (!updatedProvider.lastname || updatedProvider.lastname.length > 50) {
      newErrors.last_name = "Last name must be up to 30 characters long";
      toast.error(newErrors.last_name);
    }

    if (!updatedProvider.email) {
      newErrors.email = "Email is required";
      toast.error(newErrors.email);
    } else if (!validateEmail(updatedProvider.email)) {
        newErrors.email = "Invalid email format";
        toast.error(newErrors.email);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSave = async (e) => {
    e.preventDefault();
      try {
        if (!isEdited) {
          toast.info("No changes detected. Please update team member profile before saving.");
          return; 
        }

        if (!isSaved && validateForm()) {

          const request = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/specialist/editprovider/${id}`,
            updatedProvider
          );

          if (request.data.success) {
            toast.success(request.data.message);
            setIsSaved(true);
            setTimeout(() => {
              navigate('/providers');
            }, 3000);
          } else {
            toast.error(request.data.message);
          }
        }
      } catch (error) {
        if (!error.response) {
          toast.error("Network connection lost. Please check your connection and try again.");
        } else {
          toast.error(error.response.data.message || "An unexpected error occurred.");
        }
      }
  };

  return (
    <div style={styles.container}>
      <ToastContainer />
      <div style={styles.header}>
        <h2 style={styles.title}>Update Provider Profile</h2>
        <div style={styles.buttonContainer}>
          <button 
            style={styles.editButton} 
            onClick={onSave} 
          >
            Save
          </button>
        </div>
      </div>
      <div style={styles.infoContainer}>
        <div style={styles.infoRow}>
          <span style={styles.span}>First Name</span>
          <input
            type="text"
            name="firstname"
            value={updatedProvider.firstname}
            onChange={handleInputChange}
            style={styles.input}
          />
        </div>

        <div style={styles.infoRow}>
          <span style={styles.span}>Last Name</span>
          <input
            type="text"
            name="lastname"
            value={updatedProvider.lastname}
            onChange={handleInputChange}
            style={styles.input}
          />
        </div>

        <div style={styles.infoRow}>
          <span style={styles.span}>Email</span>
          <input
            type="email"
            name="email"
            value={updatedProvider.email}
            onChange={handleInputChange}
            style={styles.input}
          />
        </div>

      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "1000px",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "#fff",
    fontFamily: "Poppins",
  },
  header: {
    backgroundColor: "#B760E5",
    padding: "20px 35px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
    fontSize: "21px",
    fontWeight: 600,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  infoContainer: {
    padding: "0",
    border: "0",
  },
  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 35px",
    borderBottom: "1px solid #eee",
    fontSize: "1em",
  },
  span: {
    margin: 0,
    fontSize: "17px",
    fontWeight: 600,
  },
  input: {
    width: '60%',
    padding: '8px',
    borderRadius: '4px',
    border: 'none',
    fontSize: '16px',
    fontFamily: 'Poppins',
    backgroundColor: '#F4F4F6',
    color: '#808080',
  },
  editButton: {
    backgroundColor: "#25BEFF",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: "35px",
    cursor: "pointer",
    width: "80px",
    fontSize: "10px",
    fontWeight: 500,
  },
};

export default ProviderProfileForm;
